<template lang="pug">
  .component-subscription-list.row.column
    statistics-card4(v-if="reports")
      div(slot="n1")
        p Total Subscriptions
        h2 {{reports.total_subscriptions}}
      div(slot="n2")
        p Expired Subscriptions
        h2 {{reports.expiring_subscriptions}}
      div(slot="n3")
        p Renewed subscriptions
        h2 {{reports.renewed_subscriptions}}
      div(slot="n4")
        p Renewed subscriptions Amount
        h2 {{Math.ceil(reports.renewed_subscriptions_amount)}}{{currency}}
    subscription-list-form(@filterSubscriptions="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
      header-columns(slot="before", :columns="headers")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import SubscriptionListForm from "components/structure/ui/filters/SubscriptionListForm"
  import StatisticsCard4 from "components/structure/ui/StatisticsCard4"
  import BaseList from "./BaseList"
  import HeaderColumns from "components/structure/ui/HeaderColumns"
  import {mapState} from 'vuex'

  export default {
    name: "SubscriptionList",
    components: {
      HeaderColumns,
      BaseList,
      StatisticsCard4,
      SubscriptionListForm,
    },
    data() {
      return {
        component: require("components/backoffice/Subscription"),
        headers: ["", "Subscription and Client ID", "Plan name", "B.mode", "Drivers", "Billing cycle", "Expiry", "Cost", ""],
        search: null,
        reports: null
      }
    },
    methods: {
      setSearch(search) {
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        if (search) {
          if (search.active === "") {
            delete search["active"]
          }
        }
        console.log(search)
        KeplerBackofficeSdk.subscriptions.list(page, resultsPerPage, search).all((data) => {
          callback(data)
          this.getReports(search)
        })
      },
      getReports(range) {
        let start = this.$date().startOf('month').format("Y-MM-DD");
        let end = this.$date().endOf('month').format("Y-MM-DD")
        if (range && range.expire_from && range.expire_to) {
          start = range.expire_from
          end = range.expire_to
        }

        KeplerBackofficeSdk.reports.list({start: "2019-01-01", end: "2019-12-31"}).subscriptions((data) => {
          this.reports = data
        })
      },
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// SubscriptionList.vue?01268477